/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React from "react";

function AtmsResidualsReport({ requests }: { requests: any[] }) {
  const nf = Intl.NumberFormat();
  const residuals: any[] = [];
  const denominations: any[] = [];

  const repGrandTotals: any[] = [];
  const cstGrandTotals: any[] = [];
  const rejGrandTotals: any[] = [];
  const dispGrandTotals: any[] = [];
  const remGrandTotals: any[] = [];

  let amtGrandTotal = 0;

  requests.forEach((req) => {
    req.replenishments.forEach((rep: any) => {
      const denom = denominations.find(
        (dnm) => dnm.denomination === rep.denomination
      );

      if (!denom) {
        denominations.push({ denomination: rep.denomination });
      }
    });

    const replNotes: any = {};

    req.replenishments.forEach((rep: any) => {
      replNotes[rep.denomination] = rep.notes;
    });

    const dispNotes: any = {};

    if (req.dispensedNotes) {
      req.dispensedNotes.forEach((cn: any) => {
        dispNotes[cn.denomination] = cn.notes;
      });
    } else {
      req.replenishments.forEach((rep: any) => {
        dispNotes[rep.denomination] = 0;
      });
    }

    const cstNotes: any = {};

    if (req.cassettesNotes) {
      req.cassettesNotes.forEach((cn: any) => {
        cstNotes[cn.denomination] = cn.notes;
      });
    } else {
      req.replenishments.forEach((rep: any) => {
        cstNotes[rep.denomination] = 0;
      });
    }

    const rjtNotes: any = {};

    if (req.rejectedNotes) {
      req.rejectedNotes.forEach((rn: any) => {
        rjtNotes[rn.denomination] = rn.notes;
      });
    } else {
      req.replenishments.forEach((rep: any) => {
        rjtNotes[rep.denomination] = 0;
      });
    }

    const rmnNotes: any = {};
    let totalAmount = 0;

    if (req.remainingNotes) {
      req.remainingNotes.forEach((rn: any) => {
        rmnNotes[rn.denomination] = rn.notes;
        totalAmount += rn.total;
      });
    } else {
      req.replenishments.forEach((rep: any) => {
        rmnNotes[rep.denomination] = 0;
      });
    }

    amtGrandTotal += totalAmount;

    const resInfo = {
      serialNo: req.serialNo,
      locationId: req.locationId,
      locationName: req.locationName,
      journalRoll: req.journalRoll,
      totalNotes: req.totalNotes,
      replNotes,
      dispNotes,
      cstNotes,
      rjtNotes,
      rmnNotes,
      totalAmount,
    };

    residuals.push(resInfo);
    repGrandTotals.push(replNotes);
    cstGrandTotals.push(cstNotes);
    rejGrandTotals.push(rjtNotes);
    dispGrandTotals.push(dispNotes);
    remGrandTotals.push(rmnNotes);
  });

  return (
    <div className="w-full">
      <table width="100%">
        <thead>
          <tr>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Sr. #
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "left",
                paddingLeft: "2px",
              }}
            >
              Location Id
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "left",
                paddingLeft: "2px",
              }}
            >
              Location Name
            </th>
            <th
              colSpan={denominations.length}
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Replenished Notes
            </th>
            <th
              colSpan={denominations.length}
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Received in Cassettes Notes
            </th>
            <th
              colSpan={denominations.length}
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Received in Bin Notes
            </th>
            <th
              colSpan={denominations.length}
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Dispensed Notes
            </th>
            <th
              colSpan={denominations.length + 1}
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Remaining Notes
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Bank Notes
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Journal Roll
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Remarks
            </th>
          </tr>
          <tr>
            {denominations.map((dnm, i) => {
              return (
                <th
                  key={`repl${i}`}
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {dnm.denomination}
                </th>
              );
            })}

            {denominations.map((dnm, i) => {
              return (
                <th
                  key={`repl${i}`}
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {dnm.denomination}
                </th>
              );
            })}

            {denominations.map((dnm, i) => {
              return (
                <th
                  key={`disp${i}`}
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {dnm.denomination}
                </th>
              );
            })}

            {denominations.map((dnm, i) => {
              return (
                <th
                  key={`cst${i}`}
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {dnm.denomination}
                </th>
              );
            })}

            {denominations.map((dnm, i) => {
              return (
                <th
                  key={`rej${i}`}
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {dnm.denomination}
                </th>
              );
            })}

            <th
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Total
            </th>
          </tr>
        </thead>
        <tbody>
          {residuals.map((res, i) => {
            return (
              <tr key={`row${i}`}>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                    width: "80px",
                  }}
                >
                  {res.serialNo}
                </td>
                <td
                  style={{
                    textAlign: "left",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {res.locationId}
                </td>
                <td
                  style={{
                    textAlign: "left",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {res.locationName}
                </td>

                {denominations.map((dnm, ind) => {
                  const denom = dnm.denomination;
                  return (
                    <td
                      key={`rn${ind}`}
                      style={{
                        textAlign: "center",
                        border: "0.02rem solid grey",
                        fontSize: "0.6rem",
                      }}
                    >
                      {res.replNotes[denom]
                        ? nf.format(res.replNotes[denom])
                        : 0}
                    </td>
                  );
                })}

                {denominations.map((dnm, ind) => {
                  const denom = dnm.denomination;
                  return (
                    <td
                      key={`cn${ind}`}
                      style={{
                        textAlign: "center",
                        border: "0.02rem solid grey",
                        fontSize: "0.6rem",
                      }}
                    >
                      {res.cstNotes[denom] ? nf.format(res.cstNotes[denom]) : 0}
                    </td>
                  );
                })}

                {denominations.map((dnm, ind) => {
                  const denom = dnm.denomination;
                  return (
                    <td
                      key={`rjn${ind}`}
                      style={{
                        textAlign: "center",
                        border: "0.02rem solid grey",
                        fontSize: "0.6rem",
                      }}
                    >
                      {res.rjtNotes[denom] ? nf.format(res.rjtNotes[denom]) : 0}
                    </td>
                  );
                })}

                {denominations.map((dnm, ind) => {
                  const denom = dnm.denomination;
                  return (
                    <td
                      key={`rn${ind}`}
                      style={{
                        textAlign: "center",
                        border: "0.02rem solid grey",
                        fontSize: "0.6rem",
                      }}
                    >
                      {res.dispNotes[denom]
                        ? nf.format(res.dispNotes[denom])
                        : 0}
                    </td>
                  );
                })}

                {denominations.map((dnm, ind) => {
                  const denom = dnm.denomination;
                  return (
                    <td
                      key={`dn${ind}`}
                      style={{
                        textAlign: "center",
                        border: "0.02rem solid grey",
                        fontSize: "0.6rem",
                      }}
                    >
                      {res.rmnNotes[denom] ? nf.format(res.rmnNotes[denom]) : 0}
                    </td>
                  );
                })}
                <td
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {res.totalAmount ? nf.format(res.totalAmount) : 0}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {res.totalNotes ? nf.format(res.totalNotes) : 0}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {res.journalRoll}
                </td>
                <td
                  style={{
                    textAlign: "left",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {res.remarks}
                </td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <td
              colSpan={3}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              Total
            </td>

            {denominations.map((dnm, i) => {
              const denom = dnm.denomination;
              let total = 0;

              repGrandTotals.forEach((ct) => {
                total += ct[denom] ? ct[denom] : 0;
              });
              return (
                <td
                  key={i}
                  style={{
                    border: "0.02rem solid grey",
                    fontSize: "0.7rem",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  {nf.format(total)}
                </td>
              );
            })}

            {denominations.map((dnm, i) => {
              const denom = dnm.denomination;
              let total = 0;

              cstGrandTotals.forEach((ct) => {
                total += ct[denom] ? ct[denom] : 0;
              });
              return (
                <td
                  key={i}
                  style={{
                    border: "0.02rem solid grey",
                    fontSize: "0.7rem",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  {nf.format(total)}
                </td>
              );
            })}

            {denominations.map((dnm, i) => {
              const denom = dnm.denomination;
              let total = 0;

              rejGrandTotals.forEach((ct) => {
                total += ct[denom] ? ct[denom] : 0;
              });
              return (
                <td
                  key={i}
                  style={{
                    border: "0.02rem solid grey",
                    fontSize: "0.7rem",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  {nf.format(total)}
                </td>
              );
            })}

            {denominations.map((dnm, i) => {
              const denom = dnm.denomination;
              let total = 0;

              dispGrandTotals.forEach((ct) => {
                total += ct[denom] ? ct[denom] : 0;
              });
              return (
                <td
                  key={i}
                  style={{
                    border: "0.02rem solid grey",
                    fontSize: "0.7rem",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  {nf.format(total)}
                </td>
              );
            })}

            {denominations.map((dnm, i) => {
              const denom = dnm.denomination;
              let total = 0;

              remGrandTotals.forEach((ct) => {
                total += ct[denom] ? ct[denom] : 0;
              });
              return (
                <td
                  key={i}
                  style={{
                    border: "0.02rem solid grey",
                    fontSize: "0.7rem",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  {nf.format(total)}
                </td>
              );
            })}

            <td
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              {nf.format(amtGrandTotal)}
            </td>
            <td
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                fontWeight: "bold",
                textAlign: "center",
              }}
            />

            <td
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                fontWeight: "bold",
                textAlign: "center",
              }}
            />
            <td
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                fontWeight: "bold",
                textAlign: "center",
              }}
            />
          </tr>
        </tfoot>
      </table>
    </div>
  );
}

export default React.memo(AtmsResidualsReport);
